
import * as React from 'react';
import InstallPWA from '../pwa/InstallPWA';

const HeaderWithPWA: React.FC = () => {
  return (
    <div className="inline-flex items-center">
      <InstallPWA />
    </div>
  );
};

export default HeaderWithPWA;
